"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteHighlighted = exports.useEditHighlighted = void 0;
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const successData = (response) => {
    if (response?.isSuccess) {
        return response;
    }
    throw response;
};
const useEditHighlighted = (id, options) => {
    return (0, react_query_1.useMutation)(async () => {
        const response = await (0, ObjectivesClient_1.putHighlightedGoal)(id);
        successData(response);
    }, options);
};
exports.useEditHighlighted = useEditHighlighted;
const useDeleteHighlighted = (id, options) => {
    return (0, react_query_1.useMutation)(async () => {
        const response = await (0, ObjectivesClient_1.deleteHighlightedGoal)(id);
        successData(response);
    }, options);
};
exports.useDeleteHighlighted = useDeleteHighlighted;
